export const ANIMATION_TYPE_MAP = {
    SLIDE_IN_OUT: 'SLIDE_IN_OUT',
    DROPDOWN_COLLAPSE: 'DROPDOWN_COLLAPSE',
    FADE_IN_OUT: 'FADE_IN_OUT',
};
